import React from 'react'

export const CommonIntro = () => {
  const smsLoginEnabled = process.env.SMS_LOGIN_ENABLED === 'true'
  return (
    <>
      <p>
        To get started, we need your <strong>email</strong>{' '}
        {smsLoginEnabled && (
          <>
            or <strong>mobile number</strong>
          </>
        )}{' '}
        so that you will be able to access your consent dashboard.
      </p>

      <p>
        Please enter your <strong>email</strong>
        {smsLoginEnabled && (
          <>
            or <strong>mobile number</strong>
          </>
        )}
        . We'll send you a secure code you can use to login.
      </p>
    </>
  )
}
